import moment from "moment";

const DATE_FORMATS = ["YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"];

export const clientDateOfBirthForForm = (value) => {
  const text = value == null ? "" : String(value).trim();
  if (!text) return "";

  for (const format of DATE_FORMATS) {
    const parsed = moment(text, format, true);
    if (parsed.isValid()) return parsed.format("DD/MM/YYYY");
  }

  return text;
};
